import { useState } from "react";
import style from "./wheel.module.css";
import Button from "../button/Button";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { gameAction } from "../../store/game/slice";
import { configAction } from "../../store/config/slice";
import { GameStep } from "../../types/config";
import { sendScore } from "../../store/game/action";
import { getUser } from "../../store/login/action";
import { getProducts } from "../../store/products/actions";
import Message from "../message/Message";
import useWebEngageClickGame from "../../hooks/webengage/useWebEngageClickGame";
import SpecialChanceBoard from "../SpecialChanceBoard/SpecialChanceBoard";
import ShareBox from "../shareButton/ShareBox";
const Wheel = () => {
  const dispatch = useAppDispatch();
  const [isPlay, setIsPlay] = useState<boolean>(false);
  const [deg, setDeg] = useState<number>(0);
  const [actualDeg, setActualDeg] = useState<number>(0);
  const [error, setError] = useState(false);

  const { token } = useAppSelector((state) => state.config);
  const { selectedCategory } = useAppSelector((state) => state.categories);
  const user = useAppSelector((state) => state.login.user.data?.data?.user);
  const { tracWebEngageClickGame } = useWebEngageClickGame();
  const handlePlayWheel = function () {
    tracWebEngageClickGame();
    setIsPlay(true);
    dispatch(gameAction.setIsPalyGame(true));
    dispatch(sendScore(token!, selectedCategory?.category!)).then(
      (response) => {
        if (response?.status_code === 200) {
          dispatch(getProducts(response.data.coupon.api_url));
          const key = response.data.coupon.key;
          switch (key) {
            case 1:
              setDeg(10 * 360 + 30);
              break;
            case 2:
              setDeg(10 * 360 + 55);
              break;
            case 3:
              setDeg(10 * 360 + 109);
              break;
            case 4:
              setDeg(10 * 360 + 157);
              break;
            case 5:
              setDeg(10 * 360 + 201);
              break;
            case 6:
              setDeg(10 * 360 + 257);
              break;
            case 7:
              setDeg(10 * 360 + 286);
              break;
            case 8:
              setDeg(10 * 360 + 349);
              break;
          }
        } else if (response?.status_code === 403) {
          dispatch(configAction.setGameStep(GameStep.CHANCE));
        } else {
          setError(true);
          setIsPlay(false);
          dispatch(gameAction.setIsPalyGame(false));
        }
      }
    );
    window.history.pushState({}, "", "?");
  };
  const handleEndWheel = function () {
    setIsPlay(false);
    dispatch(gameAction.setIsPalyGame(false));
    setActualDeg(deg % 360);
    dispatch(configAction.setGameStep(GameStep.GAMERESULT));
    dispatch(getUser(token!));
  };
  const handleChangeCategory = function () {
    dispatch(configAction.setGameStep(GameStep.CATEGORY));
    window.history.pushState({}, "", "?");
  };
  const isSpecialChance = selectedCategory?.type === "is_special";

  return (
    <div className={style.game}>
      {error && (
        <Message
          text="مشکلی پیش آمده است لطفا مجدد تلاش کنید"
          reload
          seconds={[1000, 15000, 17000]}
        />
      )}
      <div
        className={`${style.inner} ${
          isSpecialChance ? "" : style["inner-desktop"]
        } `}
      >
        <div className={`${style["title-row"]} slide-right`}>
          <div className={style.title}>
            <span>
              {isSpecialChance
                ? "گردونه‌ی ویژه رو بچرخون!"
                : "گردونه رو بچرخون!"}
            </span>
          </div>
          {!isSpecialChance && (
            <div className={style.category}>
              <div className={style["category-title"]}>
                <span>دسته‌بندی:</span>
              </div>
              <div className={style["category-dadge"]}>
                <img src={selectedCategory?.icon} alt="" />
                <span>{selectedCategory?.name}</span>
              </div>
            </div>
          )}

          <Button
            onclick={handlePlayWheel}
            dice
            text="بچرخون"
            disable={isPlay}
            className={`my-6 ${!isPlay ? "hover" : ""}`}
            isSpecial={isSpecialChance}
          />
          <Button
            onclick={handleChangeCategory}
            text="تغییر دسته‌بندی"
            disable={isPlay}
            outlline
            className={`${isSpecialChance ? "" : style.change} ${
              !isPlay ? "hover" : ""
            }`}
          />
        </div>
        <div className={`${style["main-game"]} fade-in-1`}>
          <div className={style.stand}>
            {!isSpecialChance ? (
              <img
                src={`${process.env.PUBLIC_URL}/assets/wheel/stand.png`}
                alt="wheel"
              />
            ) : (
              <img
                src={`${process.env.PUBLIC_URL}/assets/wheel/stand-gold.png`}
                alt="wheel"
              />
            )}
          </div>

          {/* <div className={style.shadow}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/wheel/shadow.png`}
              alt="wheel"
            />
          </div> */}
          <div
            className={style.wheel}
            onClick={handlePlayWheel}
            style={{
              pointerEvents: isPlay ? "none" : "auto",
              cursor: "pointer",
            }}
          >
            <div className={style["arrow-wheel"]}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/wheel/${
                  isSpecialChance ? "arrow-gold" : "arrow"
                }.svg`}
                alt=""
              />
            </div>
            <img
              src={`${process.env.PUBLIC_URL}/assets/wheel/${
                isSpecialChance ? "circle-gold" : "circle"
              }.png`}
              alt="wheel"
              style={{ zIndex: 1 }}
            />
            <img
              className={style["main-wheel"]}
              src={selectedCategory?.wheel}
              alt="arrow"
              onTransitionEnd={handleEndWheel}
              style={{
                pointerEvents: isPlay ? "none" : "auto",
                transition: isPlay
                  ? "all 8s cubic-bezier(0.12, 0, 0, 0.99) 0s"
                  : "none",
                transform: isPlay
                  ? `rotate(${deg}deg)`
                  : `rotate(${actualDeg}deg)`,
              }}
            />
          </div>
        </div>
        {isSpecialChance && (
          <div className={style["special-chance-board-container"]}>
            <SpecialChanceBoard withDescription />
            <ShareBox id={user?.refId!} isSpecial />
          </div>
        )}
      </div>
    </div>
  );
};
export default Wheel;
